<template>
  <div>
    <div class="operating-tips_wrappers">
      <p class="mb-1">{{ $l("tips_color_operating") || "操作提示" }}</p>
      <p>
        {{ $l("tips_color_operating_1") || "1、素色面料填写面料可选基础色" }}
      </p>
      <p>
        {{
          $l("tips_color_operating_2") ||
            "2、梭织印花面料，填写可选颜色+花型图案"
        }}
      </p>
    </div>

    <div class="d-flex align-items-stretch my-3">
      <div class="side-frame"></div>
      <div class="d-flex align-items-center">
        <span style="font-size: 14px; color: #606266">
          No：{{ formData.fabricColorNo || "New" }}
        </span>
        <el-divider direction="vertical" />
        <el-tag
          size="mini"
          :type="
            formData.fabricColorStatus === 'U'
              ? 'success'
              : formData.fabricColorStatus === 'D'
              ? 'danger'
              : ''
          "
        >
          {{ formData.v_fabricColorStatus || "New" }}
        </el-tag>
        <el-divider direction="vertical" />
        <span style="font-size: 14px; color: #606266">
          Modify：{{ formData.modifyByName || "--" }} at
          {{ formData.modifyDate || "--" }}
        </span>
      </div>
    </div>

    <div class="d-flex">
      <div>
        <el-image
          :src="defaultImageUrl"
          :preview-src-list="[defaultImageUrl]"
          style="width: 200px; height: 132px"
          fit="cover"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic.jpg"
              style="width: 200px; height: 132px"
            />
          </div>
        </el-image>
        <div class="d-flex">
          <el-button
            plain
            size="small"
            style="width: 100%;"
            @click="chooseImageVisible = true"
          >
            {{ $l("btn_chooseImage") || "选择已有图片" }}
          </el-button>
          <el-button
            plain
            size="small"
            style="width: 100%;"
            @click="uploadImage"
          >
            {{ $l("btn_uploadImage") || "上传图片" }}
          </el-button>
        </div>
      </div>

      <div style="flex: 1;" class="pl-3">
        <el-form ref="form" :model="formData" :rules="rules" size="mini">
          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_fabricColorTitle') || '面料中文颜色'"
                prop="fabricColorTitle"
              >
                <el-input
                  v-model="formData.fabricColorTitle"
                  :placeholder="
                    $l('INDEX.tips_input_placeholder') || '请输入...'
                  "
                  maxlength="100"
                  show-word-limit
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_fabricColorTitleEn') || '面料英文颜色'"
                prop="fabricColorTitleEn"
              >
                <el-input
                  v-model="formData.fabricColorTitleEn"
                  :placeholder="
                    $l('INDEX.tips_input_placeholder') || '请输入...'
                  "
                  maxlength="100"
                  show-word-limit
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                :label="
                  $l('form_label_isCustomerExclusiveColor') ||
                    '是否客户专属颜色'
                "
                prop="isCustomerExclusiveColor"
              >
                <el-select
                  v-model="formData.isCustomerExclusiveColor"
                  :placeholder="
                    $l('INDEX.tips_select_placeholder') || '请选择...'
                  "
                  clearable
                  style="width: 100%"
                >
                  <el-option :label="$l('INDEX.option_no') || '否'" value="N" />
                  <el-option
                    :label="$l('INDEX.option_yes') || '是'"
                    value="Y"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>

    <ChooseImage
      :visible.sync="chooseImageVisible"
      :fabricCode="fabricCode"
      @check="checkImage"
    />

    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l("INDEX.tips_question_save") || "是否要保存更改" }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l("INDEX.btn_cancel") || "取消" }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l("INDEX.btn_no_save") || "不保存" }}
        </el-button>
        <el-button @click="save()" type="primary" size="small">
          {{ $l("INDEX.btn_save") || "保存" }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { VXETable } from "vxe-table";
import validate from "@/libs/util.validate";
import EditLoading from "@/mixins/edit-loading";
import ChooseImage from "../choose-image";
export default {
  components: { ChooseImage },
  mixins: [EditLoading],
  props: {
    fabricCode: { type: String, default: "" },
    fabricColorCode: { type: String, default: "" },
  },
  data() {
    return {
      formData: {
        defaultImageCode: "",
        defaultImageUrl: "",
        isCustomerExclusiveColor: "N",
      },
      backDialogVisible: false,
      rules: {
        fabricColorTitle: [
          {
            required: true,
            message: this.$l("INDEX.tips_input_placeholder") || "请输入...",
            trigger: "blur",
          },
        ],
        fabricColorTitleEn: [
          {
            required: true,
            message: this.$l("INDEX.tips_input_placeholder") || "请输入...",
            trigger: "blur",
          },
        ],
        isCustomerExclusiveColor: [
          {
            required: true,
            message: this.$l("INDEX.tips_select_placeholder") || "请选择...",
            trigger: "change",
          },
        ],
      },
      chooseImageVisible: false,
    };
  },
  computed: {
    defaultImageUrl() {
      const { defaultImageUrl } = this.formData;
      return defaultImageUrl || "/image/static/img/nopic.jpg";
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      if (!this.fabricColorCode) return;
      const res = await this.$api
        .masterFabricColor_DetailApi({ fabricColorCode: this.fabricColorCode })
        .catch(() => null);
      this.formData = res?.body || {};
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form]);
      if (!result) return;

      if (this.loadingOpen()) return;
      const res = await this.$api
        .masterFabricColor_SaveApi({
          ...this.formData,
          fabricCode: this.fabricCode,
        })
        .catch(() => null);
      this.loadingClose();
      if (!res) return;
      const { status } = res || {};
      if (status !== 200) {
        this.$message.error(this.$l("INDEX.tips_save_no") || "保存失败！");
        return;
      }
      this.$message({
        showClose: true,
        message: this.$l("INDEX.tips_save_ok") || "保存成功！",
        type: "success",
      });
      this.close();
      this.$emit("reload");
    },
    cancel() {
      this.backDialogVisible = true;
    },
    close() {
      this.backDialogVisible = false;
      this.$emit("close");
    },
    checkImage({ displayImageCode, displayImageUrl }) {
      this.formData.defaultImageCode = displayImageCode;
      this.formData.defaultImageUrl = displayImageUrl;
    },
    async uploadImage() {
      const { file } = await VXETable.readFile({
        types: ["jpeg", "JPEG", "jpg", "JPG", "png", "PNG", "gif", "GIF"],
      }).catch(() => ({}));
      if (!file) return;

      if (this.loadingOpen()) return;
      const res = await this.$api
        .SYS_UPLOAD(file)
        .then((res) => ({
          originImageCode: res.body.fileId,
          originImageUrl: res.body.url,
          originImageSpec: file.type,
        }))
        .catch(() => null);
      if (!res) {
        this.$message.error(
          this.$l("INDEX.uploader_label_status_error") || "上传失败"
        );
        this.loadingClose();
        return;
      }

      const params = { ...res, fabricCode: this.fabricCode };
      const saveRes = await this.$api
        .masterFabricImageUploadApi(params)
        .catch(() => null);
      this.loadingClose();
      if (!saveRes) return;
      const { status } = saveRes;
      if (status !== 200) {
        this.$message.error(
          this.$l("INDEX.uploader_label_status_error") || "上传失败"
        );
        return;
      }

      const { displayImageCode, displayImageUrl } = saveRes.body;
      this.formData.defaultImageCode = displayImageCode;
      this.formData.defaultImageUrl = displayImageUrl;
    },
  },
};
</script>

<style lang="scss" scoped>
.side-frame {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
  margin-bottom: 3px;
}
.operating-tips_wrappers {
  background-color: #fff6f7;
  border-left: 4px solid #fe6c6f;
  padding: 10px 15px;
  border-radius: 0px 4px 4px 0px;
  p {
    font-size: 14px;
    color: #101010;
    margin-bottom: 0;
    line-height: 1.7;
  }
}
</style>
